export const units = (...gridUnits) => gridUnits.map(u => `${u * 0.5}rem`).join(' ');
//# sourceMappingURL=spacing.js.map